export default __webpack_public_path__ + "static/media/frame.e214f0a4.svg";